const ITEMS = [
  "Everyone is Welcome",
  "Sunday Service · 6:30pm",
  "The Northfield Centre",
  "Co-operative Street, Stafford",
  "Healing before every Sunday service",
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="px-8 font-serif text-xl sm:text-2xl italic text-[#F7ECD9] whitespace-nowrap">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-[#C59B4B]/70" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="welcome-marquee"
    className="relative overflow-hidden border-y border-[#C59B4B]/60 bg-[#6B21A8] py-5"
  >
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </div>
);
